<template>
    <v-dialog :model-value="modelValue" max-width="520" persistent
              @update:model-value="(v) => emits('update:modelValue', v)">
        <v-card>
            <v-card-title>{{ existing ? 'Edit IP Restriction' : 'Add IP Restriction' }}</v-card-title>
            <v-card-text>
                <v-form @submit.prevent="save">
                    <v-text-field v-model="formData.ip_address" :error-messages="errors.ip_address"
                                  density="compact" hint="Single IP (e.g. 1.2.3.4) or CIDR (e.g. 10.0.0.0/24)"
                                  label="IP or CIDR" persistent-hint required/>
                    <v-text-field v-model="formData.description" :error-messages="errors.description"
                                  class="mt-4" density="compact"
                                  hint="Optional. Helps service techs identify the entry later."
                                  label="Description (optional)"/>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn variant="text" @click="emits('update:modelValue', false)">Cancel</v-btn>
                <v-btn :loading="saving" color="primary" variant="flat" @click="save">
                    {{ existing ? 'Save' : 'Add' }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {reactive, ref, watch} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const props = defineProps({
    modelValue: Boolean,
    userId: {type: [String, Number], required: true},
    existing: {type: Object, default: null},
});
const emits = defineEmits(['update:modelValue', 'saved']);
const {showSnackbar} = useSnackbarStore();

const formData = reactive({
    ip_address: '',
    description: '',
});
const errors = ref({});
const saving = ref(false);

watch(() => props.existing, (val) => {
    formData.ip_address = val?.ip_address || '';
    formData.description = val?.description || '';
    errors.value = {};
}, {immediate: true});

const save = () => {
    errors.value = {};
    saving.value = true;
    const method = props.existing ? 'put' : 'post';
    const url = props.existing
        ? `admin/users/${props.userId}/allowed-ips/${props.existing.id}`
        : `admin/users/${props.userId}/allowed-ips`;
    send(method, url, formData)
        .then((response) => {
            if (response.data.success) {
                showSnackbar(response.data.message);
                emits('saved', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch((error) => {
            if (error?.response?.status === 422) {
                errors.value = error.response.data.errors || {};
            } else {
                const msg = error?.response?.data?.message || 'Could not save entry.';
                showSnackbar(msg, 'error');
            }
        })
        .finally(() => {
            saving.value = false;
        });
};
</script>
